const Actions = {
  FETCH_ALL_AVAILABLE_RESOURCES: "FETCH_ALL_AVAILABLE_RESOURCES",
  FETCH_ALL_AVAILABLE_RESOURCES_SUCCESS:
    "FETCH_ALL_AVAILABLE_RESOURCES_SUCCESS",
  FETCH_ALL_AVAILABLE_RESOURCES_FAILURE:
    "FETCH_ALL_AVAILABLE_RESOURCES_FAILURE",
};

export default Actions;
